import { render, staticRenderFns } from "./PublicationPattern.vue?vue&type=template&id=0c1e7fb8&scoped=true"
import script from "./PublicationPattern.vue?vue&type=script&lang=js"
export * from "./PublicationPattern.vue?vue&type=script&lang=js"
import style0 from "./PublicationPattern.vue?vue&type=style&index=0&id=0c1e7fb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1e7fb8",
  null
  
)

export default component.exports